import {
  legacy_createStore as createStore,
  combineReducers,
  applyMiddleware,
} from "redux";

import createSagaMiddleware from "redux-saga";
import activeInactiveDataReducer from "./reducers/activeInactiveDataReducer";
import cartItemCountDataReducer from "./reducers/cartItemCountDataReducer";
import commisionsDataReducer from "./reducers/commisionsDataReducer";
import contactInfoDataReducer from "./reducers/contactInfoDataReducer";
import earningsDataReducer from "./reducers/earningsDataReducer";
import notificationReducer from "./reducers/errorReducer";
import lcoIdDataReducer from "./reducers/lcoIdDataReducer";
import loaderReducer from "./reducers/loaderReducer";
import screenSizeReducer from "./reducers/screenSizeReducer";
import ticketTrackerDataReducer from "./reducers/ticketTrackerDataReducer";
import userDetailsReducer from "./reducers/userDetailsReducer";
import winbackDataReducer from "./reducers/winbackUpgradeReducer";
import rootSaga from "./sagas";
import forbiddenReducer from "./reducers/forbiddenReducer";
import statementDataReducer from "./reducers/statementDataReducer";
import productListDataReducer from "./reducers/productListDataReducer";
import commonConfigDataReducer from "./reducers/commonConfigDataReducer";
import captureImageReducer from "./reducers/captureImageReducer";
import manageTeamReducer from "./reducers/manageTeamReducer";
import cdtFiltersDataReducer from "./reducers/cdtFiltersDataReducer";
import scmHeaderDataReducer from "./reducers/scmHeaderDataReducer";
import scmCatalogFiltersReducer from "./reducers/scmCatalogFiltersReducer";

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  combineReducers({
    loadingState: loaderReducer,
    notificationReducer: notificationReducer,
    screenSizeReducer,
    earningsData: earningsDataReducer,
    activeInactiveData: activeInactiveDataReducer,
    commisionsData: commisionsDataReducer,
    lcoIdData: lcoIdDataReducer,
    winbackData: winbackDataReducer,
    ticketTrackerData: ticketTrackerDataReducer,
    contactInfoData: contactInfoDataReducer,
    userDetails: userDetailsReducer,
    forbidden: forbiddenReducer,
    cartItemData: cartItemCountDataReducer,
    statementData: statementDataReducer,
    productListData: productListDataReducer,
    commonConfigData: commonConfigDataReducer,
    captureImageData: captureImageReducer,
    manageTeamData: manageTeamReducer,
    cdtFilters: cdtFiltersDataReducer,
    scmHeaderData: scmHeaderDataReducer,
    scmCatalogFilters: scmCatalogFiltersReducer,
  }),
  applyMiddleware(sagaMiddleware)
);

sagaMiddleware.run(rootSaga);
export default store;
